import { useCallback } from 'react';
import { rage } from '~/rage';
import {
	IModalReplyDefault,
	ModalButtonColor,
	ModalType,
	WalletType,
} from '~/shared';
import { useLayoutSelector } from '../redux';

const useSaveCharacter = () => {
	const gender = useLayoutSelector((state) => state.characterEditor.gender);
	const parentsValue = useLayoutSelector(
		(state) => state.characterEditor.parentsValue,
	);
	const faceMorphValues = useLayoutSelector(
		(state) => state.characterEditor.faceMorphValues,
	);
	const overlayValues = useLayoutSelector(
		(state) => state.characterEditor.overlayValues,
	);

	const handleAppearanceUpdateReply = useCallback(
		(result: IModalReplyDefault) => {
			if (!result.isAccepted) {
				return;
			}
		},
		[gender, parentsValue, faceMorphValues, overlayValues],
	);

	const handleShowAppearanceUpdateModal = useCallback(
		(walletType: WalletType) => {
			rage.modal.showModal(
				{
					type: ModalType.Price,
					title: 'Подтверждение',
					text: `Вы действительно хотите оплатить ${
						walletType === WalletType.Cash ? 'наличными' : 'картой'
					} изменение внешности?`,
					acceptButton: { text: 'Оплатить', color: ModalButtonColor.Success },
					cancelButton: { text: 'Отменить', color: ModalButtonColor.Secondary },
					price: 200000,
					wallet: walletType,
				},
				handleAppearanceUpdateReply,
			);
		},
		[handleAppearanceUpdateReply],
	);

	const handleUpdate = useCallback(
		(walletType: WalletType) => {
			handleShowAppearanceUpdateModal(walletType);
		},
		[handleShowAppearanceUpdateModal],
	);

	return {
		handleUpdate,
	};
};

export { useSaveCharacter };
